import { useQueryClient } from '@tanstack/react-query';
import { notification, Spin } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { useCompletePayment } from '@/features/invoices/api/use-complete-payment';

const InvoiceConfirmationPage = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();

  const orderReference = searchParams.get('order_reference');
  const paymentReference = searchParams.get('payment_reference');

  const completePaymentMutation = useCompletePayment({
    mutationConfig: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.includes('invoices') || query.queryKey.includes('contracts-saldo'),
        });
        window.location.href = '/invoices';
      },
    },
  });

  useEffect(() => {
    if (!orderReference || !paymentReference) {
      return;
    }

    completePaymentMutation.mutate(
      {
        data: {
          orderReference,
          paymentReference,
        },
      },
      {
        onError: () => {
          notification.error({
            message: t('somethingWentWrong', { ns: 'common' }),
          });
        },
      },
    );
  }, []);

  return (
    <div className="w-full flex justify-center mt-20">
      <Spin spinning={true} size="large" />
    </div>
  );
};

export default InvoiceConfirmationPage;
